import React, { useState, useEffect } from 'react';
import './Resources.css';
import SpotlightCard from './SpotlightCard';
import CurvedLoop from './CurvedLoop';

const Resources: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const resources = [
    {
      type: 'Artículos',
      title: 'ARTÍCULOS',
      description: 'Artículos profundos sobre liderazgo, crecimiento ministerial y desarrollo pastoral.',
      icon: `<lord-icon
        src="https://cdn.lordicon.com/fzpfudac.json"
        trigger="hover"
        colors="primary:#ffffff,secondary:#f59e0b"
        style="width:48px;height:48px">
      </lord-icon>`,
      items: [
        { title: '¿Cómo ser una iglesia misionera?', url: '/¿Cómo ser una iglesia misionera_ Por Dr. Moisés Mejía.pdf' },
        { title: 'Ay de mí si no anuncio el evangelio', url: '/Ay de mí si no anuncio el evangelio Por Dr. Moisés Mejía.pdf' },
        { title: 'Evangelismo y Discipulado Relacional, Relevante y Radical', url: '/Evangelismo y Discipulado - Un Enfoque Relacional, Relevante y Radical por Dr. Moisés Mejía.pdf' }
      ]
    }
  ];

  const videos = [
    { embedId: 'ZVpbSh3MOFU', title: 'Estrategias de Misiones en el Siglo 21' },
    { embedId: 'HJOAdr1knio', title: 'Pasión por la cosecha' },
    { embedId: 'igZ6Ay9osAI', title: 'Alcanzando al mundo budista' },
    { embedId: 'dQ2URtpbBvk', title: 'Los guardaespaldas de la oveja' }
  ];

  const VideoEmbed = ({ embedId, title }: { embedId: string; title: string }) => (
    <div className="video-wrapper">
      <div style={{ left: 0, width: '100%', height: 0, position: 'relative', paddingBottom: '56.25%' }}>
        <iframe
          src={`https://www.youtube.com/embed/${embedId}?rel=0`}
          style={{ top: 0, left: 0, width: '100%', height: '100%', position: 'absolute', border: 0 }}
          allowFullScreen
          scrolling="no"
          allow="accelerometer *; clipboard-write *; encrypted-media *; gyroscope *; picture-in-picture *; web-share *;"
          referrerPolicy="strict-origin"
          title={title}
        />
      </div>
      <p className="video-caption">{title}</p>
    </div>
  );

  return (
    <section id="recursos" className="resources">
      <div className="container">
        <h2 className="section-title">Recursos Gratuitos</h2>
        <p className="section-subtitle">
          Contenido valioso para fortalecer tu ministerio, liderazgo pastoral y visión misional y misionera.
        </p>

        <SpotlightCard
          className="articles-spotlight-card"
          spotlightColor="rgba(59, 130, 246, 0.3)"
        >
          <div
            className="resource-icon"
            dangerouslySetInnerHTML={{ __html: resources[0].icon }}
          ></div>
          <h3 className="resource-title">{resources[0].title}</h3>
          <p className="resource-description">{resources[0].description}</p>

          <div className="pdf-viewers-grid">
            {resources[0].items.map((item, index) => (
              <div key={index} className="pdf-viewer-item">
                <a href={item.url} target="_blank" rel="noopener noreferrer" className="pdf-viewer-link">
                  {isMobile ? (
                    <div className="pdf-mobile-card">
                      <div className="pdf-mobile-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                        </svg>
                      </div>
                      <div className="pdf-mobile-content">
                        <span className="pdf-mobile-title">{item.title}</span>
                        <span className="pdf-mobile-action">Toca para descargar PDF</span>
                      </div>
                    </div>
                  ) : (
                    <>
                      <iframe
                        src={`${item.url}#view=FitH`}
                        className="pdf-viewer"
                        title={item.title}
                      />
                      <div className="pdf-overlay">
                        <span className="pdf-title">{item.title}</span>
                        <span className="pdf-action">Click para ver completo</span>
                      </div>
                    </>
                  )}
                </a>
              </div>
            ))}
          </div>
        </SpotlightCard>

        <div className="videos-section">
          <div
            className="resource-icon"
            dangerouslySetInnerHTML={{
              __html: `<lord-icon
                src="https://cdn.lordicon.com/wngvbnkj.json"
                trigger="hover"
                colors="primary:#2c5282,secondary:#f59e0b"
                style="width:48px;height:48px">
              </lord-icon>`
            }}
          />
          <h3 className="videos-title">Conferencias y Enseñanzas</h3>
          <p className="videos-subtitle">Videos educativos con enseñanzas prácticas para el ministerio actual.</p>
          <div className="videos-grid">
            {videos.map((video, index) => (
              <VideoEmbed key={index} embedId={video.embedId} title={video.title} />
            ))}
          </div>
        </div>

        <CurvedLoop
          marqueeText="Misiones ✦ Evangelismo ✦ Discipulado ✦ Movilización ✦ Liderazgo ✦ Consejería ✦ Disciplinas Espirituales ✦ Retos pastorales ✦"
          speed={2}
          curveAmount={300}
          direction="right"
          interactive={false}
        />
      </div>
    </section>
  );
};

export default Resources;